import edapActions from '../../actions/edapActions';
import {log} from '../../api/logger';
import getPricingInfoFromState from './getPricingInfoFromState';

import {localizeUrl} from '@homeaway/localization-utils';

function requestToBook(store, clickedFrom) {
    const state = store.getState();
    const pricingInfo = getPricingInfoFromState(state);
    const bookingUrl = pricingInfo.checkoutUrl || null;

    if (bookingUrl) {
        store.dispatch(edapActions.triggerEdapListingBooknowClick(clickedFrom));
        log({
            bookingModalSubmit: bookingUrl
        });
        window.location.href = localizeUrl(bookingUrl, window.__SITE_CONTEXT__);
        return true;
    }

    // If no bookingUrl, log an error
    log({
        message: 'Error: missing checkoutUrl from pricingInfo object'
    });

    return false;
}

export {requestToBook};
